module.exports = __webpack_public_path__ + "img/en.6c5e3769.svg";